import {createContext, useCallback, useContext, useState} from "react";
import {ISideBarItem, ISideBarProps} from "../../models/drawer";

const SideBarContext = createContext({} as ISideBarProps);
export const useSideBarContext = () => useContext(SideBarContext);

export function SideBarProvider({ children } : { children : any}) {

  const [sideItem, setSideItem] = useState<ISideBarItem[]>([]);

  const handleSetSideBarItems = useCallback((newSideItem: ISideBarItem[]) => {
    setSideItem(newSideItem);
  }, []);

  return (
    <SideBarContext.Provider
      value={{
        setSideBarOption: handleSetSideBarItems,
        sideBarOption: sideItem,
      }}
    >
      {children}
    </SideBarContext.Provider>
  );
}
